module.exports = __webpack_public_path__ + "static/media/logov2.43804959.png";